import createReactComponent from '../createReactComponent';
export default createReactComponent('arrow-long-up-left', 'ArrowLongUpLeft', [["path",{"d":"M11 5H5v6m0-6 14 14","key":"svg-0"}]]);